import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type {
  ApplyPartMasterDataChangesRequestDto,
  ApplyPartMasterDataChangesResponseDto,
  ApplyNcFileVersionMasterDataChangesRequestDto,
  ApplyNcFileVersionMasterDataChangesResponseDto,
} from '../../generated/models';

import type {
  ApplyPartMasterDataChangesResponse,
  ApplyNcFileVersionMasterDataChangesResponse,
} from '../../domain/types';

import {
  toApplyPartMasterDataChangesResponse,
  toApplyNcFileVersionMasterDataChangesResponse,
} from '../../domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  applyPartMasterDataChanges: typedMethodPost<
    ApplyPartMasterDataChangesRequestDto,
    ApplyPartMasterDataChangesResponseDto,
    ApplyPartMasterDataChangesResponse
  >(
    (data) =>
      fetch(`${baseURL}/v1/admin/applyPartMasterDataChanges`, {
        method: 'POST',
        ...data,
      }),
    toApplyPartMasterDataChangesResponse
  ),
  applyNcFileVersionMasterDataChanges: typedMethodPost<
    ApplyNcFileVersionMasterDataChangesRequestDto,
    ApplyNcFileVersionMasterDataChangesResponseDto,
    ApplyNcFileVersionMasterDataChangesResponse
  >(
    (data) =>
      fetch(`${baseURL}/v1/admin/applyNcFileVersionMasterDataChanges`, {
        method: 'POST',
        ...data,
      }),
    toApplyNcFileVersionMasterDataChangesResponse
  ),
});

// Re-export domain types for consumers
export type {
  ApplyPartMasterDataChangesResponse,
  ApplyNcFileVersionMasterDataChangesResponse,
} from '../../domain/types';

// Re-export request DTOs (still needed for building requests)
export type {
  ApplyPartMasterDataChangesRequestDto,
  ApplyNcFileVersionMasterDataChangesRequestDto,
} from '../../generated/models';
